import { render, staticRenderFns } from "./NotificationSnack.vue?vue&type=template&id=5af7c530"
import script from "./NotificationSnack.vue?vue&type=script&lang=js"
export * from "./NotificationSnack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports